import styled, { css, InterpolationValue } from 'styled-components';
import { IconAdd } from '../../../common/components/icons/IconAdd';
import { IconSubtract } from '../../../common/components/icons/IconSubtract';
import { BorderRadius, FontWeight, FONT_STACK, PRESSABLE } from '../../../common/styles/constants';
import { ThemeColours } from '../../styles/ThemeColours';
import { onMobile } from '../../styles/onMobile';
import { P } from '../Typography/P';

export const AccordionWrapper = styled.div<{ bgColor: InterpolationValue }>`
  ${FONT_STACK}
  background-color: ${props => props.bgColor};
  border: 2px solid ${ThemeColours.mono200};
  border-radius: ${BorderRadius.SMALL};
  max-width: 850px;
  text-align: left;
  width: 100%;
`;

export const AccordionItem = styled.div`
  border-bottom: 1px solid ${ThemeColours.mono200};
  padding: 24px 30px;

  &:last-child {
    border: none;
  }
`;

export const Question = styled.div`
  align-items: center;
  color: ${ThemeColours.mono700};
  cursor: pointer;
  display: flex;
  font-size: 20px;
  font-weight: ${FontWeight.LIGHT};
  justify-content: space-between;
  margin: 0;

  ${onMobile} {
    font-size: 18px;
  }
`;

export const ButtonContainer = styled.div`
  flex-grow: 0;
  margin-inline-start: 10px;
`;

const button = css`
  background-color: transparent;
  border: 1px solid ${ThemeColours.primary};
  border-radius: 50px;
  cursor: pointer;
  fill: ${ThemeColours.primary};
  height: 32px;
  width: 32px;
  &:hover,
  :active {
    filter: brightness(90%);
  }
`;

export const ButtonAdd = styled(IconAdd)`
  ${button}
  ${PRESSABLE};
`;

export const ButtonSubtract = styled(IconSubtract)`
  ${button}
  ${PRESSABLE};
`;

export const Answer = styled(P)`
  cursor: default;
  display: block;
  font-size: 16px;
  margin: 0;
  margin-top: 24px;
  text-align: left;

  ${onMobile} {
    font-size: 14px;
  }
`;
